module.exports = __webpack_public_path__ + "5a524e7ff928507ea53898a0927b8f52.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gabriel-panel-768.webp
// module id = 348
// module chunks = 0